import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Heading,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Container,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { Postings } from "./Posts/Postings";

enum ClubInfoType {
  EMAIL,
  PHONE,
  STRING,
}

interface ClubInfo {
  type: ClubInfoType;
  name: String;
  value: String;
}

export const ofiBankGiro = "5416-8752";
export const ofiSwishNr = "1235515234";
export const ofiEmail = "osthammarfi.info@gmail.com";

export const Foreningen = () => {
  let clubInfoArray: ClubInfo[] = [
    {
      type: ClubInfoType.STRING,
      name: "Besöks- och fakturaadress",
      value: "Skolvägen 4, 74235 Östhammar",
    },
    {
      type: ClubInfoType.EMAIL,
      name: "E-post",
      value: ofiEmail,
    },
    { type: ClubInfoType.STRING, name: "Bankgiro", value: ofiBankGiro },
    { type: ClubInfoType.STRING, name: "Swish", value: ofiSwishNr },
    { type: ClubInfoType.STRING, name: "Bildad", value: "1975-01-01" },
    { type: ClubInfoType.STRING, name: "Föreningsnummer", value: "24105-16" },
    {
      type: ClubInfoType.STRING,
      name: "Organisationsnummer",
      value: "817301-3221",
    },
  ];

  return (
    <>
      <Breadcrumb mb={8}>
        <BreadcrumbItem>
          <BreadcrumbLink as={Link} to="..">
            Start
          </BreadcrumbLink>
        </BreadcrumbItem>

        <BreadcrumbItem isCurrentPage>
          <BreadcrumbLink>Föreningen</BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>

      <Container maxW="container.md" as="header" pt={4}>
        <Postings showLegend={false} category="clubinfo" />

        <Heading textAlign={"center"} style={{ marginTop: "40pt" }}>
          {" "}
          Klubbinfo{" "}
        </Heading>
        <Table variant="striped">
          <Thead>
            <Tr>
              <Th></Th>
              <Th></Th>
            </Tr>
          </Thead>
          <Tbody>
            {clubInfoArray.map((info, id) => {
              return (
                <Tr key={"info-" + id}>
                  <Td> {info.name} </Td>
                  {info.type === ClubInfoType.STRING && <Td>{info.value}</Td>}
                  {info.type === ClubInfoType.EMAIL && (
                    <Td>
                      <a className="blue-link" href={"mailto:" + info.value}>
                        {info.value}
                      </a>
                    </Td>
                  )}
                  {info.type === ClubInfoType.PHONE && (
                    <Td>
                      <a className="blue-link" href={"phoneto:" + info.value}>
                        {info.value}
                      </a>
                    </Td>
                  )}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </Container>
    </>
  );
};
